import { addressUrlAtom } from 'features/generator/contentFormSections/LocationForm/addressAtoms'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { addMissingUrlProtocol } from 'utils/urlUtils'

import {
	useFullLocation,
	useFullLocationUrl,
} from '../../../../contentFormSections/LocationForm'
import { SectionListContainer } from './SecionListContainer'

export const LocationSection = () => {
	const t = useTranslations()

	const fullLocation = useFullLocation()
	const fullLocationUrl = useFullLocationUrl()

	const addressUrl = useAtomValue(addressUrlAtom)

	return (
		<SectionListContainer>
			{fullLocation && (
				<li>
					<a
						href={
							addressUrl ? addMissingUrlProtocol(addressUrl) : fullLocationUrl
						}
						target="_blank"
						rel="nofollow ugc noreferrer"
						className="text-body-caption word-break-fix"
					>
						{fullLocation || addressUrl}
					</a>
				</li>
			)}
			{addressUrl && (
				<li>
					<a
						href={addMissingUrlProtocol(addressUrl)}
						target="_blank"
						rel="nofollow ugc noreferrer"
						className="text-body-caption text-blue"
					>
						{t(
							'generator__qr_content_screen__business_page_type__sections__show_on_map__link',
						)}
					</a>
				</li>
			)}
		</SectionListContainer>
	)
}
